import React from 'react'

const SpacingItem = () => {
    return (
        <div className='hero-bottom-line-spacing'></div>
    )
}

export default SpacingItem